// extracted by mini-css-extract-plugin
export default {"propertyDetails":"property-details_propertyDetails__2sqAf","detail":"property-details_detail__gse7D"};